<template>
    <div>
        <!-- <Loading :loadingHide="loadingHide"></Loading> -->
        <!-- <Header></Header> -->
        <div class=" lesson">
            <el-tabs  v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="待上课程" name="first">
                    <StayCourse @handleLoading="loadingHide = true"></StayCourse>
                </el-tab-pane>
                <el-tab-pane label="已上课程" name="second">
                    <BeenCourse></BeenCourse>
                </el-tab-pane>
            </el-tabs>
            
        </div>
        <!-- <Foot></Foot> -->
    </div>
</template>
<script>
import Header from '@/components/header';
import Foot from '@/components/foot';
import Loading from '@/components/loading';
import StayCourse from './component/stayCourse';
import BeenCourse from './component/beenCourse';

export default {
    components: {
        Loading,
        Header,
        Foot,
        StayCourse,
        BeenCourse
    },
    data() {
        return {
            loadingHide: false,
            activeName: 'first',
        }
    },
    methods: {
        //点击tab
        handleClick(value) {
            this.type = value.label
        },
    }
}
</script>
<style lang="scss">
.lesson {
    // padding: 80px 0;
    // min-height: 680px;
    .el-tabs__item.is-active {
        color: var(--theme-activeColor);
    }
    .el-tabs__active-bar {
        background-color: var(--theme-activeColor);
    }
    .el-tabs__item:hover {
        color: var(--theme-color);
    }
}

</style>


// WEBPACK FOOTER //
// src/views/lesson/lesson.vue